'use strict';

class LinesNumberRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement('lines-number');
        this._rootElem.component = this._model;

        this._registerListeners();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _registerListeners() {
        this._model.on("UpdateLinesNumber", this._updateLinesNumber = this._updateLinesNumber.bind(this));
    }
    _unregisterListeners() {
        this._model.removeListener("UpdateLinesNumber", this._updateLinesNumber);
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    shutdown() {
        this._unregisterListeners();

        return Promise.all([])
            .then(() => {
                this._model = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
                this._logger = undefined;
            }, (err) => {
                this._logger.warn({error: err}, 'LinesNumberRenderer.shutdown() error');
            });
    }
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        return new Promise((resolve/*,reject*/)=>{
            this._updateLinesNumber();
            resolve();
        });
    }

    getRootElement() {
        return this._rootElem;
    }
    get rootElement() {
        return this.getRootElement();
    }

    getModel() {
        return this._model;
    }
    get model(){
        return this.getModel();
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START PRIVATE RENDER METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE RENDER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    _updateLinesNumber() {
        const total = Number(this._model.total) || 0;
        const selected = Number(this._model.selected) || 0;
        let lineNumberData = '';

        if (total > 0 && selected <= total) {
            lineNumberData = `${selected} / ${total}`;
        }

        this._rootElem.innerHTML = lineNumberData;
    }

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}
module.exports = LinesNumberRenderer;